import React, { useEffect, useRef, useState } from 'react';
import s from './BestOffers.module.scss';
import { LayoutPropType } from 'src/modules/parkplusStoreV2/types/layout';
import { Typography } from 'ui-v2/components/Typography';
import cn from 'classnames';
import BestOfferCard from '../../Cards/BestOfferCard';
import useStoreItemClick from 'src/modules/parkplusStoreV2/hooks/useStoreItemClick';
import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import {
  trackCardClickedStoreV2,
  trackSectionViewedStoreV2,
} from 'src/modules/parkplusStoreV2/utils/events';

const BestOffers = ({ data }: LayoutPropType) => {
  const [selectedCategory, setSelectedCategory] = useState(
    data?.metaData?.categories[0]?.productId
  );

  const [activeTab, setActiveTab] = useState(0);

  const CARDID = data.entityType || 'BestOffersListing';

  const { handleItemClickWithDelegation } = useStoreItemClick();

  const rootRef = useRef();
  const isEventFired = useRef(false);
  const inViewPort = useComponentInViewport(rootRef, {
    threshold: 0.5,
  });
  const getIndex = (id: number) =>
    data.data.findIndex((item) => item.productId === id);

  useEffect(() => {
    if (inViewPort && !isEventFired.current) {
      trackSectionViewedStoreV2(encodeURI(data?.title));
      isEventFired.current = true;
    }
  }, [data?.title, inViewPort]);

  const handleTabClick = (idx) => {
    setActiveTab(idx);
    setSelectedCategory(data?.metaData?.categories[idx]?.productId);

    const chipEle = document.getElementById(`${data?.layoutId}-${idx}-tabs`);
    const cardEle = document.getElementById(`${data?.layoutId}-bestOfferCard`);

    if (chipEle) {
      setTimeout(() => {
        chipEle.scrollIntoView({
          block: 'nearest',
          inline: 'center',
          // behavior: 'smooth',
        });
      }, 100);
    }

    if (cardEle) {
      const timeout = setTimeout(() => {
        cardEle.scrollTo({
          left: 0,
          behavior: 'smooth',
        });
        clearTimeout(timeout);
      }, 100);
    }

    trackCardClickedStoreV2(data?.title, idx + 1);
  };

  return (
    <div
      className={s.root}
      ref={rootRef}
      onClick={(e) =>
        handleItemClickWithDelegation(
          e,
          CARDID,
          data?.entityType,
          data?.data,
          data?.title
        )
      }
    >
      <div className={s.heading}>
        <Typography label="Best offers for you" variant="label_1_bold" />
      </div>

      <div className={cn(s.categories, 'cmn_hide_scrollbar')}>
        {data?.metaData?.categories?.map((category, idx) => (
          <div
            key={`${idx}^&**()`}
            onClick={() => handleTabClick(idx)}
            className={cn(s.tab, {
              [s.activeTab]: idx === activeTab,
            })}
            id={`${data?.layoutId}-${idx}-tabs`}
          >
            <Typography
              label={category?.title}
              variant="label_3_regular"
              color={activeTab === idx ? 'on_dark_bg' : 'primary'}
            />
          </div>
        ))}
      </div>

      <div
        className={cn(s.categoryCards, 'cmn_hide_scrollbar')}
        id={`${data?.layoutId}-bestOfferCard`}
      >
        {data?.data
          ?.filter((item) => +item?.parentId === +selectedCategory)
          .map((card, idx) => (
            <div key={card?.productId}>
              <BestOfferCard
                card={card}
                id={CARDID}
                key={card?.productId}
                index={getIndex(card?.productId)}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default BestOffers;
